import React, { useState } from "react";
import "./FilterBar.css";
import CitySelectionModal from "./CitySelectionModal";
import NearbyLocations from "./NearbyLocations.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

const FilterBar = ({
  onFilterChange,
  BedroomFilter,
  gender,
  occupancyFilter,
  furnishedFilter,
  addDays,
  citys,
  handleLocationChange,
  cityFilter,
  showCityModal,
  setShowCityModal,
  filterModal,
  area,
  removearea,
}) => {
  const [city, setCity] = useState([citys]);
  const [showGenderOptions, setShowGenderOptions] = useState(false);
  const [showBhkOptions, setShowBhkOptions] = useState(false);
  const [showFurnishedOptions, setShowFurnishedOptions] = useState(false);
  const [showOccupancyOptions, setShowOccupancyOptions] = useState(false);
  // const [area, setArea] = useState("");
  const [selectedAreas, setSelectedAreas] = useState([]);
  const ocuupency =
    occupancyFilter !== ""
      ? occupancyFilter
          .filter((property) => property.iselected == "true")
          .map((item) => item.value)
      : [];

  const closeAllTooltips = () => {
    setShowGenderOptions(false);
    setShowBhkOptions(false);
    setShowFurnishedOptions(false);
    setShowOccupancyOptions(false);
  };

  const toggleGenderOptions = () => {
    const isOpen = !showGenderOptions;
    closeAllTooltips();
    setShowGenderOptions(isOpen);
  };

  const toggleBhkOptions = () => {
    const isOpen = !showBhkOptions;
    closeAllTooltips();
    setShowBhkOptions(isOpen);
  };

  const toggleFurnishedOptions = () => {
    const isOpen = !showFurnishedOptions;
    closeAllTooltips();
    setShowFurnishedOptions(isOpen);
  };

  const toggleOccupancyOptions = () => {
    const isOpen = !showOccupancyOptions;
    closeAllTooltips();
    setShowOccupancyOptions(isOpen);
  };

  const isAnyTooltipOpen =
    showGenderOptions ||
    showBhkOptions ||
    showFurnishedOptions ||
    showOccupancyOptions;

  const handleCityClick = () => {
    setShowCityModal(true);
  };

  const handleCitySelect = (selectedCity) => {
    setCity(selectedCity);
    localStorage.setItem("city", selectedCity);

    setShowCityModal(false);
  };

  const handleSearchClick = () => {
    // if (area) {
    // setSelectedAreas([...selectedAreas, area]);
    // setArea(""); // Clear the input after adding
    // }
  };

  const removeArea = (index) => {
    const updatedAreas = selectedAreas.filter((_, i) => i !== index);
    setSelectedAreas(updatedAreas);
  };
  const handleareaChange = (value) => {
    onFilterChange("area", value);
  };

  return (
    <>
      <div className="mobile-filter">
        <div className="custom-filter-bar-row">
          <div className="custom-filter-bar">
            <div className="custom-city-dropdown" onClick={handleCityClick}>
              {citys} <span className="custom-dropdown-icon">▼</span>
            </div>
            {/* <input
            type="text"
            value={area}
            placeholder="Search Area..."
            onChange={(e) => setArea(e.target.value)}
            className="custom-area-input"
          /> */}
            <NearbyLocations
              handleareaChange={handleareaChange}
              area={area}
              hideadd={true}
            />
            <div className="location-groups"></div>
          </div>
          <div
            className=""
            onClick={filterModal}
            // style={{ marginBottom: "10px" }}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="40" height="40" rx="4" fill="#3F8EFC" />
              <path
                d="M22.8594 12.5937C21.5891 12.9078 20.5672 13.8594 20.1641 15.1062L20.0328 15.5H15.0359C10.2594 15.5 10.0297 15.5047 9.875 15.589C9.62188 15.7203 9.5 15.9359 9.5 16.25C9.5 16.564 9.61719 16.775 9.875 16.925C10.0391 17.0234 10.1 17.0234 15.0453 17.0469L20.0563 17.0703L20.1594 17.3984C20.5438 18.6172 21.5609 19.5828 22.8078 19.9156C23.3047 20.0469 24.1953 20.0469 24.6922 19.9156C25.9391 19.5828 26.9563 18.6172 27.3406 17.3984L27.4438 17.0703L28.7047 17.0469C29.8625 17.0234 29.975 17.014 30.125 16.925C30.3828 16.775 30.5 16.564 30.5 16.25C30.5 15.9359 30.3781 15.7203 30.125 15.589C29.9797 15.5094 29.8391 15.5 28.7141 15.5H27.4672L27.3359 15.1062C26.9281 13.85 25.9016 12.9031 24.6172 12.589C24.125 12.4719 23.3469 12.4719 22.8594 12.5937ZM24.3359 14.1219C24.8469 14.2531 25.3109 14.6 25.625 15.0875C25.8734 15.4719 25.9672 15.8562 25.9438 16.4C25.9297 16.7844 25.9062 16.8781 25.7516 17.2015C25.4234 17.8765 24.8188 18.3265 24.0734 18.4531C23.15 18.6078 22.1891 18.0969 21.7531 17.2109C21.5938 16.8828 21.5703 16.8031 21.5563 16.4047C21.5422 16.0765 21.5563 15.8797 21.6172 15.6594C21.8141 14.9328 22.4984 14.2672 23.2203 14.0984C23.5063 14.0328 24.0359 14.0422 24.3359 14.1219Z"
                fill="white"
              />
              <path
                d="M15.3594 20.0937C14.0891 20.4078 13.0672 21.3594 12.6641 22.6062L12.5328 23H11.2859C10.1609 23 10.0203 23.0094 9.875 23.089C9.62188 23.2203 9.5 23.4359 9.5 23.75C9.5 24.064 9.61719 24.275 9.875 24.425C10.025 24.514 10.1375 24.5234 11.2953 24.5469L12.5563 24.5703L12.6594 24.8984C13.0438 26.1172 14.0609 27.0828 15.3078 27.4156C15.8047 27.5469 16.6953 27.5469 17.1922 27.4156C18.4391 27.0828 19.4563 26.1172 19.8406 24.8984L19.9438 24.5703L24.9547 24.5469C29.9 24.5234 29.9609 24.5234 30.125 24.425C30.3828 24.275 30.5 24.064 30.5 23.75C30.5 23.4359 30.3781 23.2203 30.125 23.089C29.9703 23.0047 29.7406 23 24.9641 23H19.9672L19.8359 22.6062C19.4281 21.35 18.4016 20.4031 17.1172 20.089C16.625 19.9719 15.8469 19.9719 15.3594 20.0937ZM16.8359 21.6219C17.3469 21.7531 17.8109 22.1 18.125 22.5875C18.3734 22.9719 18.4672 23.3562 18.4438 23.9C18.4297 24.2844 18.4062 24.3781 18.2516 24.7015C17.9234 25.3765 17.3188 25.8265 16.5734 25.9531C15.65 26.1078 14.6891 25.5969 14.2531 24.7109C14.0938 24.3828 14.0703 24.3031 14.0563 23.9047C14.0422 23.5765 14.0563 23.3797 14.1172 23.1594C14.3141 22.4328 14.9984 21.7672 15.7203 21.5984C16.0063 21.5328 16.5359 21.5422 16.8359 21.6219Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className="added-area-box">
          <div className="custom-selected-areas">
            {area &&
              area.map((item, index) => {
                return (
                  item != "" && (
                    <div
                      style={{ marginTop: "10px" }}
                      key={index}
                      className={`location-button rounded-pill selected`}
                      onClick={() => {
                        removearea(item);
                      }}
                    >
                      {item}{" "}
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="xmark"
                        class="svg-inline--fa fa-xmark "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                      >
                        <path
                          fill="currentColor"
                          d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                        ></path>
                      </svg>
                    </div>
                  )
                );
              })}
            {/* {area.map((area, index) => (
          <div key={index} className="custom-area-tag">
            {area}{" "}
            <span
              onClick={() => removeArea(index)}
              className="custom-remove-icon"
            >
              ✕
            </span>
          </div>
        ))} */}
          </div>
        </div>

        <div className={`filter-bar ${isAnyTooltipOpen ? "no-scroll" : ""}`}>
          <div className="filter-options">
            <div className="filter-button">
              <button className="gender-button" onClick={toggleGenderOptions}>
                {gender || "Gender"}
                <span className="dropdown-arrow">▼</span>
              </button>
              {showGenderOptions && (
                <div className="gender-tooltip">
                  <div
                    className={`gender-option  ${
                      gender === "male" ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("gender", "male")}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_4283_5051)">
                        <path
                          d="M5.9625 3.32109C6.10625 6.77109 6.10625 6.80703 5.9625 8.10078C5.85469 9.125 5.87266 9.16094 6.50156 9.75391C6.86094 10.0773 7.14844 10.4727 7.14844 10.6164C7.14844 11.3172 7.75937 12.7547 8.37031 13.4555C9.16094 14.3539 9.16094 15.0188 8.40625 15.2523C8.15469 15.3242 6.91484 15.7016 5.63906 16.0609C3.23125 16.7617 2.5125 17.175 2.00937 18.1453C1.72187 18.6844 0.5 22.8531 0.5 23.2664C0.5 23.4461 2.92578 23.5 12 23.5C21.0742 23.5 23.5 23.4461 23.5 23.2664C23.5 22.8531 22.2781 18.7023 22.0086 18.1813C21.4695 17.1391 20.8945 16.8156 17.9836 15.9531C15.4859 15.1984 15.1445 15.0547 15.0367 14.6773C14.9648 14.3539 15.1086 14.0484 15.6297 13.4555C16.2406 12.7547 16.8516 11.3172 16.8516 10.6164C16.8516 10.4727 17.1391 10.0773 17.4984 9.75391C18.1273 9.16094 18.1453 9.125 18.0375 8.10078C17.8937 6.77109 17.8937 6.60938 18.0375 4.99219C18.1273 3.75234 18.1094 3.57266 17.6242 2.65625C17.2289 1.88359 16.8875 1.54219 16.1328 1.075L15.1625 0.5H10.5086H5.85469L5.9625 3.32109ZM15.3422 2.40469C16.2406 3.06953 16.582 3.69844 16.582 4.63281C16.582 5.11797 16.5281 5.54922 16.4742 5.60312C16.4203 5.675 16.007 5.51328 15.5758 5.26172C14.5336 4.66875 13.8148 4.70469 12.3953 5.3875C11.3711 5.89062 10.9937 5.98047 9.48438 6.03438C7.43594 6.12422 7.56172 6.26797 7.38203 3.59063L7.27422 1.91953L11.0656 1.97344C14.5516 2.02734 14.893 2.06328 15.3422 2.40469ZM15.0727 6.96875C15.45 7.36406 15.9172 7.6875 16.1148 7.6875C16.5281 7.6875 16.7437 8.19063 16.4742 8.51406C16.3664 8.65781 16.043 8.76562 15.7555 8.76562H15.2344V9.9875C15.2344 11.0297 15.1625 11.3352 14.7133 12.018C13.4016 14.0844 10.4547 14.0305 9.21484 11.9281C8.85547 11.3172 8.76562 10.9219 8.76562 9.96953V8.76562H8.24453C7.65156 8.76562 7.27422 8.40625 7.43594 7.975C7.52578 7.75938 7.79531 7.6875 8.65781 7.6875C10.4008 7.6875 12.018 7.36406 13.0781 6.80703C13.6172 6.51953 14.1383 6.26797 14.2281 6.26797C14.318 6.25 14.6953 6.57344 15.0727 6.96875ZM13.5813 15.4141C13.7789 16.6359 12.7188 17.4266 11.425 17.0492C11.0477 16.9234 10.6703 16.6898 10.5625 16.4922C10.3828 16.1688 10.3109 15.1805 10.4547 15.0367C10.4906 15.0008 11.2094 14.9828 12.0359 15.0008C13.4195 15.0188 13.5273 15.0547 13.5813 15.4141ZM9.84375 17.9836L10.2391 18.2531L9.77187 18.5586C9.52031 18.7203 9.23281 18.8102 9.125 18.7383C8.92734 18.6125 8.51406 17.8578 8.33437 17.2648C8.13672 16.6719 8.78359 16.6359 9.16094 17.2289C9.32266 17.4984 9.62813 17.8398 9.84375 17.9836ZM15.6656 17.2828C15.4859 17.8578 15.0727 18.6125 14.875 18.7383C14.7672 18.8102 14.4797 18.7203 14.2281 18.5586L13.7789 18.2711L14.318 17.8219C14.6234 17.5703 14.9109 17.2289 14.9648 17.0492C15.0367 16.8156 15.1805 16.7438 15.432 16.7977C15.7016 16.8695 15.7555 16.9953 15.6656 17.2828ZM7.05859 18.2891C7.23828 18.8461 7.6875 19.5648 8.20859 20.1219L9.05312 21.0383L10.4547 20.0141C11.2453 19.457 11.9281 19.0078 12 19.0078C12.0719 19.0078 12.7547 19.457 13.5453 20.0141L14.9469 21.0383L15.7914 20.1219C16.2586 19.6008 16.7617 18.8102 16.9594 18.307C17.1391 17.8039 17.3188 17.3906 17.3727 17.3906C17.6961 17.4086 19.8703 18.1633 20.2117 18.3789C20.5711 18.6305 21.0023 19.7086 21.4516 21.5773L21.5594 22.0625H20.2836H19.0078V21.0742V20.0859H18.1992H17.3906V21.0742V22.0625H12H6.60938V21.0742V20.0859H5.80078H4.99219V21.0742V22.0625H3.71641H2.44062L2.54844 21.5594C2.92578 20.032 3.41094 18.6664 3.6625 18.4688C3.91406 18.2352 6.12422 17.4266 6.55547 17.4086C6.66328 17.3906 6.89687 17.8039 7.05859 18.2891Z"
                          fill="#ABB7C2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4283_5051">
                          <rect
                            width="23"
                            height="23"
                            fill="white"
                            transform="translate(0.5 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Male</span>
                  </div>
                  <div
                    className={`gender-option ${
                      gender === "female" ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("gender", "female")}
                  >
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_0_591)">
                        <path
                          d="M9.6187 0.762501C6.97495 1.625 4.8187 4.04375 4.31245 6.70625C4.19995 7.25 4.12495 9.5 4.12495 11.75C4.12495 16.2688 4.27495 17.1125 5.2312 18.3125L5.7937 19.025L4.9312 19.3438C3.2812 19.9813 2.21245 21.4063 1.4062 24.0688L1.2937 24.5H12H22.7062L22.5937 24.0688C21.7875 21.4063 20.7187 19.9813 19.0687 19.3438L18.2062 19.025L18.7687 18.3125C19.725 17.1125 19.875 16.2688 19.875 11.7313C19.875 9.425 19.7812 7.2125 19.6687 6.65C19.1625 4.325 17.5687 2.2625 15.3937 1.19375C14.3062 0.668751 13.9875 0.593752 12.3 0.556252C11.0812 0.518751 10.125 0.593752 9.6187 0.762501ZM14.55 2.58125C16.6125 3.5375 18.1875 5.88125 18.1875 7.94375V8.80625L17.7187 8.3C17.475 8.0375 16.8937 7.64375 16.4437 7.45625C15.525 7.0625 14.8312 6.3125 14.6812 5.525C14.5875 5.0375 14.5125 5 13.7625 5C13.05 5 12.9375 5.05625 12.9375 5.39375C12.9375 5.975 12.3937 6.78125 11.7375 7.175C11.325 7.41875 10.6875 7.53125 9.4687 7.5875C7.31245 7.6625 7.08745 7.71875 6.3937 8.3L5.81245 8.7875V7.925C5.81245 5.43125 7.94995 2.8625 10.5937 2.16875C11.55 1.90625 13.5562 2.13125 14.55 2.58125ZM14.1187 7.86875C14.175 8 14.7375 8.39375 15.375 8.73125C16.05 9.0875 16.6687 9.59375 16.8562 9.89375C17.025 10.2125 17.3437 10.4375 17.625 10.475C17.9812 10.5125 18.0937 10.6438 18.0937 11C18.0937 11.3938 18 11.4875 17.4937 11.525C16.95 11.5813 16.8562 11.675 16.575 12.5563C15.9749 14.375 13.9125 15.875 12 15.875C10.0875 15.875 8.02495 14.375 7.42495 12.5563C7.1437 11.675 7.04995 11.5813 6.5062 11.525C5.99995 11.4875 5.9062 11.3938 5.9062 11C5.9062 10.625 6.0187 10.5125 6.4312 10.475C6.71245 10.4375 6.93745 10.325 6.93745 10.2313C6.93745 10.1188 7.1437 9.8375 7.4062 9.59375C7.8187 9.1625 8.0062 9.125 9.5062 9.125C11.5125 9.125 12.3937 8.9 13.1812 8.1875C13.8562 7.56875 13.9875 7.53125 14.1187 7.86875ZM7.46245 15.5375C7.9312 16.025 8.54995 16.5125 8.84995 16.6438C9.18745 16.775 9.37495 17 9.37495 17.2625C9.37495 17.825 9.18745 18.0313 8.4562 18.275C7.87495 18.4813 7.76245 18.4625 7.19995 18.0313C6.26245 17.3188 5.81245 16.1938 5.81245 14.5438L5.8312 13.1563L6.22495 13.9063C6.4312 14.3188 6.9937 15.05 7.46245 15.5375ZM17.7937 16.7375C17.5875 17.2063 17.1187 17.7875 16.8 18.0313C16.2375 18.4625 16.125 18.4813 15.5437 18.275C14.8125 18.0313 14.625 17.825 14.625 17.2438C14.625 16.9813 14.775 16.7938 15.0375 16.7C15.6937 16.4938 17.3437 14.825 17.7374 13.9625L18.0937 13.1563L18.15 14.5438C18.1875 15.6313 18.1312 16.0813 17.7937 16.7375ZM13.1062 17.975C13.3875 18.7625 12.975 19.25 12 19.25C11.025 19.25 10.6125 18.7625 10.8937 17.975C11.0812 17.4125 11.1562 17.375 12 17.375C12.8437 17.375 12.9187 17.4125 13.1062 17.975ZM10.575 20.5813C10.9875 20.7688 11.6437 20.9375 12 20.9375C12.75 20.9375 14.1375 20.3563 14.3625 19.9438C14.5125 19.7 14.8312 19.7563 16.575 20.2813C17.6999 20.6375 18.8437 21.0125 19.0875 21.1625C19.5187 21.3875 20.4375 22.55 20.4375 22.85C20.4375 22.9438 16.65 23 12 23C7.3687 23 3.56245 22.9438 3.56245 22.85C3.56245 22.55 4.4812 21.3875 4.91245 21.1625C5.1562 21.0125 6.29995 20.6375 7.42495 20.2813C9.1687 19.7563 9.48745 19.7 9.63745 19.9438C9.71245 20.0938 10.1437 20.375 10.575 20.5813Z"
                          fill="#ABB7C2"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_0_591">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="translate(0 0.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <span>Female</span>
                  </div>
                  <div
                    className={`gender-option  ${
                      gender == "" ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("gender", "")}
                  >
                    <svg
                      width="28"
                      height="29"
                      viewBox="0 0 28 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.5125 4.28438C4.41875 4.7 3.28125 5.70625 2.82188 6.7125C2.51563 7.39062 2.40625 8.13437 2.40625 9.88438C2.40625 12.5312 2.77813 13.625 4.09063 14.6969L4.85625 15.3313L3.5875 15.7031C1.94688 16.1625 0.940625 16.7969 0.415625 17.65C0.065625 18.2406 0 18.7875 0 21.6531V25H2.64688H5.27188L5.20625 24.4094C5.1625 23.9719 5.00938 23.775 4.65938 23.7313C4.24375 23.6656 4.17813 23.5125 4.1125 22.4188C4.04688 21.2594 4.00313 21.1719 3.5 21.1719C2.99688 21.1719 2.95313 21.2594 2.8875 22.4188L2.82188 23.6875H1.96875H1.09375V21.8719C1.11563 18.5687 1.53125 17.7812 3.71875 17.0813L4.8125 16.7312L5.55625 17.475C6.65 18.5687 8.00625 18.4594 9.07813 17.2125L9.51563 16.7094L10.6969 17.1031C11.3313 17.3219 12.1188 17.7812 12.4469 18.0875C12.9938 18.6344 13.0156 18.8094 13.0813 21.1719L13.1688 23.6875H12.2719H11.375V22.375C11.375 21.1281 11.3531 21.0625 10.85 21.0625C10.2375 21.0625 10.0625 21.4125 10.0625 22.7031C10.0625 23.5344 9.99688 23.6656 9.58125 23.7313C9.20938 23.775 9.07813 23.95 9.07813 24.3438V24.8906L13.7375 24.9563C17.7406 25 18.3969 24.9563 18.5063 24.6719C18.6813 24.2344 18.2219 23.6875 17.6969 23.6875C17.3688 23.6875 17.2813 23.4688 17.2375 22.4188C17.1719 21.2594 17.1281 21.1719 16.625 21.1719C16.1219 21.1719 16.0781 21.2594 16.0125 22.4188L15.9469 23.6875H15.2031H14.4375V21.2156C14.4594 18.1312 14.7 17.7375 17.15 17.0156C17.9813 16.775 18.025 16.7969 18.6156 17.4313C19.1406 18.0219 19.3594 18.1094 20.3438 18.1094C21.3281 18.1094 21.5469 18.0219 22.05 17.4531C22.6844 16.6875 23.0344 16.6875 24.6313 17.475C25.2875 17.7812 25.8344 18.2188 25.9875 18.5469C26.1406 18.875 26.25 20.1219 26.25 21.3906V23.6875H25.4844H24.7406L24.675 22.4188C24.6094 21.2375 24.5875 21.1719 24.0188 21.1063C23.4063 21.0406 23.4063 21.0406 23.4063 22.3531C23.4063 23.5125 23.3625 23.6875 22.9906 23.6875C22.4656 23.6875 22.0063 24.2344 22.1813 24.6719C22.2906 24.9563 22.7281 25 24.8719 24.9563L27.4531 24.8906L27.5188 21.85C27.5625 19.2469 27.5188 18.7 27.1688 17.9781L26.7531 17.1469L27.2781 16.6219C27.5844 16.3156 27.8688 15.7469 27.9344 15.2438C28.0219 14.4125 28 14.3688 26.9938 13.8438C25.3531 12.9906 25.1125 12.4875 24.9156 9.75313C24.6313 5.46563 23.4719 4 20.3656 4C18.8125 4 18.0469 4.2625 17.1938 5.05C16.2531 5.94687 15.925 6.93125 15.7719 9.6C15.5969 12.4219 15.2688 13.0781 13.6719 13.8438C13.125 14.1062 12.6438 14.4125 12.5563 14.5219C12.3594 14.8281 12.8625 16.1406 13.3438 16.5781C14.0656 17.2125 13.8469 17.4313 13.1031 16.8188C12.7313 16.5125 11.7469 16.0531 10.9156 15.7906L9.3625 15.3313L10.15 14.675C10.5875 14.3031 11.1563 13.6469 11.375 13.1656C11.9438 12.05 12.1625 9.5125 11.8125 7.87188C11.2219 5.02813 8.20313 3.32187 5.5125 4.28438ZM8.37813 5.61875C9.60313 6.14375 10.7188 7.78438 10.7188 9.11875C10.7188 9.46875 7.9625 9.05313 6.9125 8.55C6.08125 8.15625 5.81875 8.1125 5.5125 8.33125C5.31563 8.48438 4.85625 8.74688 4.48438 8.9C3.87188 9.20625 3.82813 9.18437 3.7625 8.76875C3.63125 8.06875 3.89375 7.36875 4.52813 6.60312C5.55625 5.4 7 5.02813 8.37813 5.61875ZM22.3344 5.88125C22.925 6.40625 23.3188 7.17188 23.4938 8.2L23.6469 9.03125H22.8375C22.2031 9.03125 21.875 8.87813 21.3063 8.26562C20.9125 7.85 20.475 7.5 20.3219 7.5C20.1688 7.5 19.7313 7.85 19.3375 8.26562C18.7906 8.87813 18.4844 9.03125 17.85 9.03125C16.975 9.03125 16.9313 8.94375 17.3031 7.60938C17.5656 6.66875 18.2219 5.81563 18.9219 5.50937C19.6875 5.18125 21.8094 5.4 22.3344 5.88125ZM21.0438 9.90625C21.4813 10.1687 22.1594 10.3438 22.7281 10.3438H23.6688L23.5156 11.1531C23.2969 12.3125 22.6188 13.1875 21.5031 13.6687C20.3656 14.1719 19.4906 14.0625 18.3969 13.2531C17.6531 12.6844 17.0625 11.5906 17.0625 10.7812C17.0625 10.4313 17.1938 10.3438 17.8938 10.3438C18.5719 10.3438 19.0313 10.1906 20.2781 9.49063C20.3219 9.49063 20.65 9.66563 21.0438 9.90625ZM7.76563 10.2563C8.35625 10.4313 9.275 10.5625 9.8 10.5625H10.7625L10.6094 11.2625C10.1063 13.5813 8.15938 14.9156 6.25625 14.2812C4.74688 13.7781 3.71875 12.5531 3.71875 11.2406C3.71875 10.6719 3.82813 10.5406 4.55 10.3438C4.9875 10.2344 5.5125 10.0375 5.6875 9.90625C5.8625 9.79688 6.16875 9.75313 6.34375 9.84062C6.51875 9.90625 7.15313 10.1031 7.76563 10.2563ZM17.9375 15.0469C17.9375 15.5063 15.3344 16.2719 14.7656 15.9875C13.9781 15.5719 14.0219 15.3094 14.9844 14.6969C15.5094 14.3688 16.0344 13.8875 16.1656 13.6687C16.3844 13.2531 16.4281 13.2531 17.1719 13.9969C17.5875 14.4125 17.9375 14.8938 17.9375 15.0469ZM25.7688 14.7406L26.7094 15.3313L26.1188 15.7906C25.7688 16.075 25.375 16.2063 25.1781 16.1188C24.9813 16.0531 24.3688 15.8562 23.8 15.6813C23.2094 15.5063 22.75 15.2219 22.75 15.0469C22.75 14.8938 23.0781 14.4344 23.4719 14.0188C24.15 13.2969 24.1719 13.2969 24.5 13.7125C24.675 13.9531 25.2438 14.4125 25.7688 14.7406ZM21.4375 15.5938C21.4375 16.1406 20.8031 16.9062 20.3438 16.9062C19.8844 16.9062 19.25 16.1406 19.25 15.5938C19.25 15.3531 19.5125 15.2656 20.3438 15.2656C21.175 15.2656 21.4375 15.3531 21.4375 15.5938ZM8.09375 16.075C8.09375 16.4469 7.48125 16.9062 7.02188 16.9062C6.7375 16.9062 6.125 16.2719 6.125 15.9656C6.125 15.7906 6.49688 15.7031 7.10938 15.7031C7.89688 15.7031 8.09375 15.7688 8.09375 16.075Z"
                        fill="#ABB7C2"
                      />
                      <path
                        d="M5.6878 12.1808C5.44717 12.4871 5.46905 12.5965 5.7753 12.9465C6.32217 13.559 7.10967 13.6683 8.00655 13.2965C8.61905 13.0558 8.77217 12.8808 8.70655 12.4871C8.64092 11.984 8.61905 11.984 7.10967 12.1152C7.0003 12.1152 6.69405 12.0715 6.43155 11.984C6.14717 11.8965 5.88467 11.9621 5.6878 12.1808Z"
                        fill="#ABB7C2"
                      />
                      <path
                        d="M6.71563 23.8406C6.62813 23.9062 6.5625 24.2125 6.5625 24.4969C6.5625 24.8906 6.69375 25 7.0875 25C7.37188 25 7.67813 24.8469 7.74375 24.65C7.98438 24.0375 7.15313 23.4031 6.71563 23.8406Z"
                        fill="#ABB7C2"
                      />
                      <path
                        d="M19.7755 24.0159C19.688 24.1909 19.7099 24.4972 19.7755 24.6941C19.9505 25.1534 20.8692 25.0003 20.9567 24.4753C21.088 23.7972 20.0161 23.3816 19.7755 24.0159Z"
                        fill="#ABB7C2"
                      />
                    </svg>

                    <span>Both</span>
                  </div>
                </div>
              )}
            </div>

            <div className="filter-button">
              <button className="bedroom-button" onClick={toggleBhkOptions}>
                {/* {(Array.isArray() && BedroomFilter.length === 0) ||
                !BedroomFilter
                  ? "Bedroom"
                  : BedroomFilter} */}
                {(Array.isArray(BedroomFilter) && BedroomFilter.length === 0) ||
                !BedroomFilter
                  ? "Bedroom"
                  : BedroomFilter.join(", ")}{" "}
                <span className="dropdown-arrow">▼</span>
              </button>
              {showBhkOptions && (
                <div className="bhk-tooltip">
                  <div>
                    <div className="bhk-row">
                      <div
                        // className={`bhk-option ${
                        //   BedroomFilter == "1rk" ? "selected" : ""
                        // }`}
                        className={`bhk-option ${
                          BedroomFilter.includes("1rk")
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => onFilterChange("bedroom", "1rk")}
                      >
                        <span>1rk</span>
                      </div>
                      <div
                        // className={`bhk-option ${
                        //   BedroomFilter == "1 BHK" ? "selected" : ""
                        // }`}
                        className={`bhk-option ${
                          BedroomFilter.includes("1 BHK")
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => onFilterChange("bedroom", "1 BHK")}
                      >
                        <span>1 BHK</span>
                      </div>

                      <div
                        // className={`bhk-option ${
                        //   BedroomFilter == "2 BHK" ? "selected" : ""
                        // }`}
                        className={`bhk-option ${
                          BedroomFilter.includes("2 BHK")
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => onFilterChange("bedroom", "2 BHK")}
                      >
                        <span>2 BHK</span>
                      </div>
                    </div>
                    <div className="bhk-row">
                      <div>
                        <div
                          // className={`bhk-option ${
                          //   BedroomFilter == "3 BHK" ? "selected" : ""
                          // }`}
                          className={`bhk-option ${
                            BedroomFilter.includes("3 BHK")
                              ? "selected"
                              : ""
                          }`}
                          onClick={() => onFilterChange("bedroom", "3 BHK")}
                        >
                          <span>3 BHK</span>
                        </div>
                      </div>

                      <div
                        // className={`bhk-option ${
                        //   BedroomFilter == "4 BHK" ? "selected" : ""
                        // }`}
                        className={`bhk-option ${
                          BedroomFilter.includes("4 BHK")
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => onFilterChange("bedroom", "4 BHK")}
                      >
                        <span>4 BHK</span>
                      </div>
                      <div
                        // className={`bhk-option ${
                        //   BedroomFilter == "5 BHK" ? "selected" : ""
                        // }`}
                        className={`bhk-option ${
                          BedroomFilter.includes("5 BHK")
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => onFilterChange("bedroom", "5 BHK")}
                      >
                        <span>5 BHK</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="filter-button">
              <button className="dropbtn" onClick={toggleOccupancyOptions}>
                {(Array.isArray(ocuupency) && ocuupency.length === 0) ||
                !ocuupency
                  ? "Occupancy Type"
                  : ocuupency.join(", ")}{" "}
                {/* {ocuupency.includes("Single") == true ? "Single" : ""}
                {""}
                {ocuupency.includes("Double") == true ? "Double " : ""}
                {""}
                {ocuupency.includes("Triple") == true ? "Triple" : ""}
                {""}
                {ocuupency.length == 0 ? "Occupancy Type" : ""}{" "} */}
                <span className="dropdown-arrow">▼</span>
              </button>
              {showOccupancyOptions && (
                <div className="occupancy-tooltip">
                  <div
                    className={`bhk-option ${
                      ocuupency.includes("Single") == true ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("Occupancy", "0")}
                  >
                    <span>Single</span>
                  </div>
                  <div
                    className={`bhk-option ${
                      ocuupency.includes("Double") == true ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("Occupancy", "1")}
                  >
                    <span>Double</span>
                  </div>

                  <div
                    className={`bhk-option ${
                      ocuupency.includes("Triple") == true ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("Occupancy", "2")}
                  >
                    <span>Triple</span>
                  </div>
                </div>
              )}
            </div>

            <div className="filter-button">
              <button className="dropbtn" onClick={toggleFurnishedOptions}>
                {/* {furnishedFilter || "Furnished Type"} */}
                {/* {(Array.isArray(furnishedFilter) &&
                  furnishedFilter.length === 0) ||
                !furnishedFilter
                  ? "Furnished Type"
                  : furnishedFilter} */}
                {(Array.isArray(furnishedFilter) &&
                  furnishedFilter.length === 0) ||
                !furnishedFilter
                  ? "Furnished Type"
                  : furnishedFilter.join(", ")}{" "}
                {/* Join selected types */}
                <span className="dropdown-arrow">▼</span>
              </button>
              {showFurnishedOptions && (
                <div className="furnished-tooltip">
                  <div
                    // className={`furnished-option ${
                    //   furnishedFilter == "fully-furnished" ? "selected" : ""
                    // }`}
                    className={`furnished-option ${
                      furnishedFilter.includes("fully-furnished")
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      onFilterChange("Furnisher", "fully-furnished")
                    }
                  >
                    <span>Furnished</span>
                  </div>
                  <div
                    // className={`furnished-option ${
                    //   furnishedFilter == "unfurnished" ? "selected" : ""
                    // }`}
                    className={`furnished-option ${
                      furnishedFilter.includes("unfurnished") ? "selected" : ""
                    }`}
                    onClick={() => onFilterChange("Furnisher", "unfurnished")}
                  >
                    <span>Unfurnished</span>
                  </div>

                  <div
                    // className={`furnished-option ${
                    //   furnishedFilter == "semi-furnished" ? "selected" : ""
                    // }`}

                    className={`furnished-option ${
                      furnishedFilter.includes("semi-furnished")
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      onFilterChange("Furnisher", "semi-furnished")
                    }
                  >
                    <span>Semi-furnished</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showCityModal && (
        <CitySelectionModal
          // cities={city}
          onClose={() => setShowCityModal(false)}
          onSelectCity={handleCitySelect}
          selectedCity={city} // Pass selected city here
          isMobileView={window.innerWidth <= 768} // Adjust for mobile view
          handleLocationChange={handleLocationChange} //SAVE CITY IN FILTER
          cityFilter={cityFilter}
        />
      )}
    </>
  );
};

export default FilterBar;
